import type { ReactNode } from "react";
import { SmartHeader } from "@/features/showcase/components/SmartHeader";
import { resolveCanonicalAppPath } from "@/lib/auth/landing";
import { useAuthStore } from "@/lib/auth/authStore";
import { GlobalBackButton } from "@/shared/ui";
import { useLocation } from "react-router-dom";

interface Props { children: ReactNode }

export const PublicAppShell = ({ children }: Props): JSX.Element => {
  const { accessToken, user, profileRole, businessRole, systemRole } = useAuthStore();
  const { pathname } = useLocation();
  const isAuthenticated = Boolean(accessToken && user);
  const dashboardHref = resolveCanonicalAppPath({ systemRole, profileRole, businessRole });
  return (
    <div className="min-h-screen bg-background">
      <SmartHeader isAuthenticated={isAuthenticated} dashboardHref={dashboardHref} />
      {pathname !== "/" && pathname !== "/showcase" ? <GlobalBackButton fallbackHref="/" className="left-3 top-20 sm:left-5" /> : null}
      <main>{children}</main>
    </div>
  );
};
